<template>
  <div>
    <FloatingMenu />

    <div id="notFoundPage" v-if="this.langChosen == 'gr'">
      <transition enter-active-class="animated fadeIn" appear>
        <div class="aboutUsPageTitle">이 페이지를 찾을 수 없습니다.</div>
      </transition>

      <div class="heroImage" />

      <div class="contactContainer">
        <p>
          죄송합니다. 찾고있는 페이지가 없습니다. (더 길어질 수 있음) 주소를 다시 확인하거나 집으로 돌아가십시오.
        </p>

        <div class="backToHome" @click="this.$route.push('/home')">
          <router-link to="/home">홈으로</router-link>
        </div>
      </div>
    </div>

    <div id="notFoundPage" v-else>
      <transition enter-active-class="animated fadeIn" appear>
        <div class="aboutUsPageTitle">Page Not Found</div>
      </transition>

      <div class="heroImage" />

      <div class="contactContainer">
        <p>Sorry, the page you looking for isn't exist (maybe anymore). Check your address again or go back to home.</p>

        <div class="backToHome" @click="this.$route.push('/home')">
          <router-link to="/home">Back to home</router-link>
        </div>
      </div>
    </div>

    <FifthSection />
  </div>
</template>

<script>
import FloatingMenu from '../components/FloatingMenu';
import FifthSection from '../components/FifthSection';

export default {
  components: {
    FloatingMenu,
    FifthSection,
  },

  mounted() {
    this.setDocTitle();
  },

  methods: {
    setDocTitle() {
      const langChosen = localStorage.getItem('langChosen');
      if (langChosen == 'gr') return (document.title = '우리에 대해 - 부산 복권');
      document.title = 'About Us - Busan Lotteries';
    },
  },
};
</script>

<style>
#notFoundPage {
  background: url('../assets/backgroundFirstSection.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 100vw;
  padding: 5vw;
  padding-top: 3.75vh;
  box-sizing: border-box;
}

.aboutUsPageTitle {
  font-size: 165%;
  font-weight: bold;
  color: var(--lightColor);
  margin-bottom: 5.5vw;
}

#notFoundPage .heroImage {
  height: 35vh;
  background: url('../assets/404.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 2vw 2vw 0 0;
  overflow: hidden;
}

.contactContainer {
  background-color: white;
  padding: 4vw;
  border-radius: 0 0 2vw 2vw;
  font-size: 0.98em;
}

.contactContainer p {
  margin: 0;
  margin-bottom: 3vw;
}

.contactContainer p:last-child {
  margin-bottom: 1vw;
}

.backToHome {
  background-color: var(--infoColor);
  width: auto;
  border-radius: 2vw;
  padding: 3vw 6vw;
  font-weight: bold;
  text-align: center;
  margin: 6vw 0 4vw 0;
}

.backToHome a {
  text-decoration: none;
  color: var(--lightColor);
}

.backToHome:hover {
  background-color: rgba(116, 82, 77, 0.85);
}

.backToHome:active {
  background-color: rgba(116, 82, 77, 1);
}
</style>
